import React from "react";
import { useNavigate } from "react-router-dom";
import "./Terms.css"; // Shared legal UI styling

const Shipping = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="glass-background"></div>

      {/* ⭐ NAVBAR WITH LOGO */}
      <nav className="legal-nav">
        <div className="nav-brand" onClick={() => navigate("/")}>
          <img src="/icons/logo-512.png" className="nav-logo" alt="GrammAA" />
          <span className="brand-text">GrammAA</span>
        </div>
      </nav>

      {/* ⭐ CONTENT */}
      <div className="legal-content glass-panel fade-in">
        <h1>Shipping & Delivery Policy</h1>
        <p className="updated-date">Last updated: {new Date().getFullYear()}</p>

        <p>
          GrammAA is a fully digital, AI-powered grammar correction and writing
          enhancement service. We do not ship any physical products. All services
          and features are delivered instantly online.
        </p>

        <h2>1. Delivery of Digital Services</h2>
        <p>
          When you purchase a premium subscription, your account is upgraded
          immediately. You gain instant access to:
        </p>
        <ul>
          <li>Unlimited grammar checks (as per your plan)</li>
          <li>Advanced AI rewriting tools</li>
          <li>Premium features and dashboard tools</li>
        </ul>

        <h2>2. No Physical Shipping</h2>
        <p>
          Since GrammAA does not ship physical goods, there are:
        </p>
        <ul>
          <li>No delivery charges</li>
          <li>No shipping times</li>
          <li>No packaging or courier services involved</li>
        </ul>

        <h2>3. Service Activation Time</h2>
        <p>
          In most cases, premium access is activated instantly after successful
          payment. In rare cases, activation may take up to:
        </p>
        <ul>
          <li>2–10 minutes (due to payment gateway delay)</li>
        </ul>

        <p>
          If your upgrade does not reflect automatically, our team will assist
          you within a few hours.
        </p>

        <h2>4. Failed or Delayed Payment Confirmation</h2>
        <p>
          A delay may occur if your bank or Razorpay takes longer than usual to
          confirm the transaction. If your purchase status is pending, please
          contact us with:
        </p>
        <ul>
          <li>Payment ID</li>
          <li>Email used for registration</li>
          <li>Screenshot of the transaction</li>
        </ul>

        <h2>5. Contact Information</h2>
        <p>
          For issues related to activation or payment confirmation, please reach
          out to us at:
          <br />
          <strong>support@aiweb.com</strong>
        </p>

        <br />
        <p>Thank you for choosing GrammAA.</p>
      </div>
    </div>
  );
};

export default Shipping;
